export const COUPON_COMMENTS_FETCH_REQUEST = "COUPON_COMMENTS_FETCH_REQUEST";
export const COUPON_COMMENTS_FETCH_SUCCESS = "COUPON_COMMENTS_FETCH_SUCCESS";
export const COUPON_COMMENTS_FETCH_FAILURE = "COUPON_COMMENTS_FETCH_FAILURE";

export const COUPON_COMMENT_CREATE_REQUEST = "COUPON_COMMENT_CREATE_REQUEST";
export const COUPON_COMMENT_CREATE_SUCCESS = "COUPON_COMMENT_CREATE_SUCCESS";
export const COUPON_COMMENT_CREATE_FAILURE = "COUPON_COMMENT_CREATE_FAILURE";

export const COUPON_COMMENT_UPDATE_REQUEST = "COUPON_COMMENT_UPDATE_REQUEST";
export const COUPON_COMMENT_UPDATE_SUCCESS = "COUPON_COMMENT_UPDATE_SUCCESS";
export const COUPON_COMMENT_UPDATE_FAILURE = "COUPON_COMMENT_UPDATE_FAILURE";

export const COUPON_COMMENT_DELETE_REQUEST = "COUPON_COMMENT_DELETE_REQUEST";
export const COUPON_COMMENT_DELETE_SUCCESS = "COUPON_COMMENT_DELETE_SUCCESS";
export const COUPON_COMMENT_DELETE_FAILURE = "COUPON_COMMENT_DELETE_FAILURE";

export const COUPON_COMMENTS_CLEAR = "COUPON_COMMENTS_CLEAR";
